import { useSelector } from 'react-redux';
import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { MERCH_CARD } from 'pricing-pages-ui/constants/tracking/Locations';
import { upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import LoadingMerchCardAuthedCTAs from './LoadingMerchCardAuthedCTAs';
import LoadingMerchCardPublicCTAs from './LoadingMerchCardPublicCTAs';
import { useMerchCardAuthedCTAsProps } from './useMerchCardAuthedCTAsProps';
import { useMerchCardPublicCTAsProps } from './useMerchCardPublicCTAsProps';
import { jsx as _jsx } from "react/jsx-runtime";
const MerchCardCTAsContainer = props => {
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [props.skuId]
  }));
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/auth-cta-motions/AuthedCTAs`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/merch-card/MerchCardPublicCTAs`),
    authedComponentProps: Object.assign({}, props, {
      trackingSource: props.trackingSource || MERCH_CARD,
      overridePurchaseMotions: props.overridePurchaseMotions,
      overrideUpgradeData: props.overrideUpgradeData
    }),
    publicComponentProps: Object.assign({}, props, {
      sourceId: props.trackingSource || 'pricing-hero',
      dtbSource: `pricing-page|${productLineToHub[props.productLine]}-hub|${props.trackingSource || MERCH_CARD}|${upgradeProduct}`
    }),
    publicComponentLoadingState: LoadingMerchCardPublicCTAs,
    authedComponentLoadingState: LoadingMerchCardAuthedCTAs,
    useCommonAuthedProps: useMerchCardAuthedCTAsProps,
    useCommonPublicProps: useMerchCardPublicCTAsProps
  });
};
export default MerchCardCTAsContainer;